import React from 'react';
export function LogoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M1 1h6v2H3v4H1V1zm0 22h6v-2H3v-4H1v6zM17 1h6v6h-2V3h-4V1z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13l-6.265 2.685a2 2 0 00-1.05 1.05L13 23h-2l-2.685-6.265a2 2 0 00-1.05-1.05L1 13v-2l6.265-2.685a2 2 0 001.05-1.05L11 1h2l2.685 6.265a2 2 0 001.05 1.05L23 11v2zM12 3.744l-1.847 4.309a4 4 0 01-2.1 2.1L3.743 12l4.31 1.847a4 4 0 012.1 2.1L12 20.258l1.847-4.31a4 4 0 012.1-2.1L20.258 12l-4.31-1.847a4 4 0 01-2.1-2.1L12 3.743z"
  }), React.createElement("path", {
    d: "M17 23h6v-6h-2v4h-4v2z"
  }));
}